export const PT_BACKGROUND = '#256F7D';
export const YOUTUBE_PT = 'https://www.youtube.com/channel/UCS2p8FhmS5mU4EiGJPwmPUw/videos'; // TODO
export const OPTIONS_KEY = 'PT OPTIONS';
export const CLUES_PAGE = 'CLUES PAGE';
export const CLUES_COLOR = 'CLUES COLOR';
export const CLUES_NUNBERS = 'CLUES NUMBERS';
export const CLUES_HINTS = 'CLUES HINTS';
export const SEEN_SOLO_OPTIONS_KEY = 'PT SEEN SOLO OPTIONS';
export const SEEN_AI_OPTIONS_KEY = 'PT SEEN AI OPTIONS';
export const SEEN_FRIEND_OPTIONS_KEY = 'PT SEEN FRIEND OPTIONS';
